import React, { useContext, useState, useEffect, createContext } from 'react';
import { AppContext } from '../App';
import { PLAY_MODES, GAME_TYPES } from '../Constants';
import { callApi, callGameServerApi } from '../Helpers';
import App  from '../games-ui/App';


export default function View(props) {
  const appContext = useContext(AppContext);
  const playMode = PLAY_MODES.ONLINE;

  const [ gameId, setGameId ] = useState(props.gameId);
  const [ loading, setLoading ] = useState(false);
  const [ gameData, setGameData ] = useState(null);
  const [ ready, setReady ] = useState(false);
  const [ user, setUser ] = useState(null);

  async function init() {
    //get game data
    setReady(false);
    setLoading(true);
    await getGameData().then(async response => {
      setGameData(response.gameData);
      await appContext.getLocalUser().then(user => {
        console.log(user);
        setUser(user);
        setReady(true);
        setLoading(false);
      })
    })
  }

  function getGameData() {
    return new Promise( async resolve => {
      await callGameServerApi('get-game-data', { gameId }).then(response => resolve(response))
    })
  }

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  useEffect(() => {
    init();
  }, [ gameId ])

  if(ready && user && gameData) {
    return(
      <App 
        gameType={gameData.type}
        gameId={gameData.uid}
        playMode={playMode}
        userId={user.userId}
        userToken={user.userToken}
        mode="play"
      />
    )
  }
}
